import axios from "axios";
const queryString = require('query-string');
export default {
    getItems(payload) {
        return axios({
            method: "POST",
            url: `/api/coupon-voucher/get-coupon-voucher`,
            withCredentials: true,
            data: payload,
        });
    },
    getCouponSubTypes(type) {
        return axios({
            method: "GET",
            url: `/api/coupon-voucher/get-sub-types/${type}`,
            withCredentials: true,
        });
    },
    getSurveys() {
        return axios({
            method: "GET",
            url: `/api/coupon-voucher/get-surveys`,
            withCredentials: true,
        });
    },
    getIssueItems(id, payload) {
        return axios({
            method: "POST",
            url: `/api/coupon-voucher/get-coupon-voucher-issue/${id}`,
            withCredentials: true,
            data: payload,
        });
    },
    upsert(payload) {
        return axios({
            method: "POST",
            url: `/api/coupon-voucher/upsert`,
            data: payload,
            withCredentials: true,
        });
    },
    delete(id) {
        return axios({
            method: "DELETE",
            url: `/api/coupon-voucher/${id}`,
            withCredentials: true,
        });
    },
    detail(id) {
        return axios({
            method: "GET",
            url: `/api/coupon-voucher/${id}`,
            withCredentials: true,
        });
    },
    acceptIssue(payload) {
        return axios({
            method: "POST",
            url: `/api/coupon-voucher/accept-issue/${payload.uuidv7}`,
            withCredentials: true,
        });
    },
    rejectIssue(payload) {
        return axios({
            method: "POST",
            url: `/api/coupon-voucher/reject-issue/${payload.uuidv7}`,
            withCredentials: true,
        });
    },
};
